module.exports = __webpack_public_path__ + "img/5-large.d591f944.png";